import { render, staticRenderFns } from "./FreeLayout.vue?vue&type=template&id=9df234f2&"
import script from "./FreeLayout.vue?vue&type=script&lang=js&"
export * from "./FreeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports